import React from "react";
import Header from "../components/Header.js";
import SideMenu from "../components/SideMenu.js";
import FiltersMenu from "../components/FiltersMenu.js";
import OverlayManager from "../components/OverlayManager";
import PopAnimationContainer from "../components/PopAnimationContainer";
import FeedbackButton from "../components/FeedbackButton";
import MainContent from "../components/MainContent";
import LoadingSpinner from "../components/LoadingSpinner";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  useUI,
  useMenu,
  useUser,
  useFilters,
  useTasks,
  useTaskActions,
  useAuthActions,
  useFetchTasks,
  useAppInitialization,
  useResponsiveLayout,
  useFontManagement,
  useEventListeners,
  useAnalytics,
  useTaskManagement,
  useFiltersMenuVisibility,
} from "../hooks/index.js";
import "../styles/App.css";

const AppPage = () => {
  const {
    appLoaded,
    isMobile,
    setIsMobile,
    setIsFullWidth,
    setAppLoaded,
    selectedFont,
  } = useUI();
  const {
    showContextMenu,
    setShowContextMenu,
    showSubscriptionMenu,
    setShowSubscriptionMenu,
    overlayContent,
    setOverlayContent,
    setContextMenuPosition,
    handleOverlayClose,
  } = useMenu();
  const { subscriptionTier, email, isDemo, preferences } = useUser();
  const { showCompleted, activeSlate } = useFilters();
  const { tasks, pop, setPop, popPosition } = useTasks();
  const { generateCategoryImages } = useTaskActions();
  const { checkAuth } = useAuthActions();
  const { fetchTasks, dependencies: fetchTasksDeps } = useFetchTasks();

  useAppInitialization(setAppLoaded, checkAuth, fetchTasks);
  useResponsiveLayout(setIsMobile, setIsFullWidth);
  useFontManagement(selectedFont);
  useEventListeners(showContextMenu, setShowContextMenu);
  useAnalytics({
    appLoaded,
    email,
    isDemo,
    subscriptionTier,
  });
  useTaskManagement(
    setPop,
    popPosition,
    preferences,
    generateCategoryImages,
    activeSlate,
    fetchTasks,
    fetchTasksDeps,
    appLoaded,
  );
  useFiltersMenuVisibility();

  if (!appLoaded) {
    return <LoadingSpinner />;
  }

  return (
    <div className="App">
      <Header loggedIn={true} />

      <FeedbackButton onClick={() => setOverlayContent("feedback")} />

      <FiltersMenu loggedIn={true} />

      <SideMenu />

      <OverlayManager
        overlayContent={overlayContent}
        handleOverlayClose={handleOverlayClose}
      />

      <PopAnimationContainer pop={pop} popPosition={popPosition} />

      <main className="main-content bubble-container">
        <MainContent
          showSubscriptionMenu={showSubscriptionMenu}
          setShowSubscriptionMenu={setShowSubscriptionMenu}
          tasks={tasks}
          showCompleted={showCompleted}
          subscriptionTier={subscriptionTier}
          email={email}
        />
      </main>

      <ToastContainer
        position="top-center"
        autoClose={10000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default AppPage;
